<div class="container">
    <h4 class="text-white font-weight-bolder">Contrats d'utilisation des services SoftPay(SPay)</h4>
    <ul class="list-group">
        <li class="list-group-item">Conditions d'utilisation du service SoftPay</li>
        <li class="list-group-item"><a routerLink="politique-de-confidentialité">Politique de confidentialité des services SoftPay</a></li>
        <li class="list-group-item">Contrat de vendeur sur une Plateforme SoftPay</li>
    </ul>
    <div id="CUSP" class="bg-white m-auto p-2">
        <h3 class="font-weight-bolder">Bienvenue chez SoftPay.</h3>
        <p>
            Vous trouverez ci-dessous les Conditions générales du contrat conclu entre vous et smart digital africa sarl
            régissant votre utilisation de votre compte SoftPay et des services SoftPay, que nous appelons nos
            Conditions d'utilisation.
            Si vous êtes un particulier,vous devez être âgé de 18 ans minimum et avoir la pleine capacité juridique pour
            conclure un contrat vous permettant d'ouvrir un compte SoftPay et
            d'utiliser les services SoftPay.
            Si vous êtes un professionnel, votre société doit être enregistrée au cameroun.

        </p>

        <p>
            Pour utiliser les services SoftPay, vous devez ouvrir un compte SoftPay. En ouvrant et en utilisant un
            compte
            SoftPay, vous acceptez de vous conformer à l'ensemble des Conditions générales stipulées dans les présentes
            Conditions d'utilisation. Vous acceptez également de vous conformer aux documents supplémentaires suivants
            et à chacun des autres documents répertoriés sur la page Contrats d'utilisation qui s'appliquent à vous :
        </p>
        <ul class="list-group">
            <li class="list-group-item border-0">Règlement sur les utilisations autorisées</li>
            <li class="list-group-item border-0">Conditions du Paiement après Livraison</li>
        </ul>
        <p>
            Lisez attentivement l'ensemble des Conditions générales énoncées dans les présentes Conditions d'utilisation
            et chacun des autres documents qui s'appliquent à vous.
        </p>
        <p>
            Nous pourrons de temps à autre réviser les présentes Conditions d'utilisation et tous les documents
            susmentionnés. La version révisée entrera en vigueur au moment de sa publication, sauf indication contraire.
            Si nos modifications réduisent vos droits ou augmentent vos responsabilités, nous publierons un avis sur la
            page Mises à jour du règlement de notre site et vous en informerons au moins deux mois à l'avance. En
            continuant à utiliser nos services après toute modification des présentes Conditions d'utilisation, vous
            acceptez d'être lié auxdites modifications. Si vous n'acceptez pas les modifications, vous pouvez fermer
            votre compte avant leur date d'entrée en vigueur.
        </p>
        <h3 class="font-weight-bolder">Informations nous concernant et concernant notre service</h3>

        <p>L'activité principale de SoftPay est l'émission d'argent électronique et la fourniture de services de
            paiement
            utilisant ledit argent électronique.</p>

        <p>Pour plus d'informations nous concernant et concernant nos services, consultez les Informations essentielles
            sur
            les paiements et le service <a href="#">ici</a>.</p>

        <p> Les présentes Conditions d'utilisation, ainsi que d'autres termes juridiques et communications légalement
            requises concernant votre utilisation de nos services, vous seront communiqués à tout moment sur le site
            SoftPay
            (habituellement sur la page "Contrats d'utilisation"). Nous pourrons également vous envoyer ces
            informations.</p>

        <!-- <p>Vous pouvez nous demander une copie de toute communication légalement requise (y compris les présentes
        Conditions d'utilisation et les Informations essentielles sur les paiements et le service) que nous vous
        fournirons sous une forme qui vous permet de stocker et de reproduire les informations (par exemple, par email).</p>-->
        <hr style="border: 1px solid gray;">
        <h3 class="font-weight-bolder">Ouvrir un compte</h3>
        <p></p>
        <p></p>
        <p>Nous proposons deux types de comptes : Particulier et Professionnel.</p>
        <hr style="border: 1px solid gray;">


        <h4 class="font-weight-bolder">Comptes Particuliers</h4>
        <p>Un compte Particulier vous permet d'envoyer de l'argent à vos proches et de payer vos achats en
            ligne et en magasin.</p>

        <p>Les titulaires de certains comptes Particuliers peuvent être tenus d'effectuer une mise à niveau de leur
            compte
            (y compris de fournir d'autres informations à SoftPay) pour pouvoir utiliser toutes les fonctionnalités
            disponibles dans un compte Particulier.</p>

        <p>Pour utiliser votre compte SoftPay principalement pour vendre des objets, vous avez besoin d'un compte
            Professionnel .</p>

            <hr style="border: 1px solid gray;">
        <h4 class="font-weight-bolder">Comptes Professionnels</h4>

        <p>un compte Professionnel ne peut etre ouvert que si vous avez déja un compte particulier</p>

        <p>Les comptes Professionnels sont destinés aux personnes et aux organisations (qu'elles soient incorporées ou non)
        qui utilisent principalement SoftPay pour recevoir des paiements en ligne correspondant à des ventes ou des dons.</p>

        <p>Les comptes Professionnels peuvent être soumis à des frais différents de ceux applicables aux comptes
        Particuliers. Consultez la section Frais pour en savoir plus.</p>

        <p>En ouvrant un compte Professionnel , vous nous
        certifiez que vous l'utilisez principalement pour une entreprise ou à des fins commerciales.</p>
        <hr style="border: 1px solid gray;">
    </div>
</div>